const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Photos are stored as backend-relative paths (/api/photos/<id>) so they work on any deployment host.
export const resolvePhotoUrl = (path) => {
  if (!path || typeof path !== 'string') return null;
  if (path.startsWith('/api/')) return `${BACKEND_URL}${path}`;
  if (/^https?:\/\//.test(path)) return path;
  return null;
};

export const firstPhotoUrl = (user) => resolvePhotoUrl((user?.images || user?.profile_images || [])[0]);
